// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";

// const API_URL = "https://web1024.docmaster.in:5010/";

// // Async Thunks
// export const fetchClassesList = createAsyncThunk(
//   "questionBank/fetchClasses",
//   async () => {
//     const response = await axios.get(`${API_URL}api/classes`);
//     return response.data;
//   }
// );

// export const fetchQuestionTypes = createAsyncThunk(
//   "questionBank/fetchQuestionTypes",
//   async () => {
//     const response = await axios.get(`${API_URL}api/subjects/question-types`);
//     return response.data;
//   }
// );

// export const fetchDifficultyLevels = createAsyncThunk(
//   "questionBank/fetchDifficultyLevels",
//   async () => {
//     const response = await axios.get(
//       `${API_URL}api/subjects/difficulty-levels`
//     );
//     return response.data;
//   }
// );

// export const getSubjects = createAsyncThunk(
//   "questionBank/getSubjects",
//   async (selectedClassId) => {
//     const response = await axios.get(
//       `${API_URL}api/subjects/link/${selectedClassId}`
//     );
//     return response.data;
//   }
// );

// export const getChapters = createAsyncThunk(
//   "questionBank/getChapters",
//   async ({ selectedClassId, selectedSubjectId }) => {
//     const response = await axios.get(
//       `${API_URL}api/chapters?subject_id=${selectedSubjectId}&classs_id=${selectedClassId}`
//     );
//     return response.data;
//   }
// );

// export const fetchQuestions = createAsyncThunk(
//   "questionBank/fetchQuestions",
//   async ({
//     selectedClassId,
//     selectedSubjectId,
//     selectedChapterId,
//     user_id,
//   }) => {
//     const response = await axios.get(
//       `${API_URL}api/questions?class_id=${selectedClassId}&subject_id=${selectedSubjectId}&chapter_id=${selectedChapterId}&created_by=${user_id}`
//     );
//     return response.data;
//   }
// );

// export const addNewQuestion = createAsyncThunk(
//   "questionBank/addQuestion",
//   async (
//     { questionData, classId, subjectId, chapterId, created_by },
//     { rejectWithValue }
//   ) => {
//     try {
//       const response = await fetch(`${API_URL}api/questions`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...questionData,
//           class_id: parseInt(classId),
//           subject_id: parseInt(subjectId),
//           chapter_id: parseInt(chapterId),
//           created_by: parseInt(created_by),
//         }),
//       });

//       if (!response.ok) {
//         const error = await response.json();
//         return rejectWithValue(error.message || "Failed to add question");
//       }
//       alert("Successfully added new question");
//       const data = await response.json();
//       console.log(data);
//       return await response.json();
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );
// export const deleteQuestion = createAsyncThunk(
//   "questionBank/deleteQuestion",
//   async (
//     { id, classId, subjectId, chapterId, questionTypeId },
//     { dispatch, rejectWithValue }
//   ) => {
//     try {
//       const response = await fetch(`${API_URL}api/questions/${id}`, {
//         method: "DELETE",
//       });

//       if (!response.ok) {
//         const error = await response.json();
//         return rejectWithValue(error.message || "Failed to delete question");
//       }

//       // Optionally show a success message here or in the component
//       alert("Successfully deleted the question");

//       // Refetch questions after deletion
//       dispatch(
//         fetchQuestions({
//           selectedClassId: classId,
//           selectedSubjectId: subjectId,
//           selectedChapterId: chapterId,
//           questionTypeId: questionTypeId,
//         })
//       );

//       return id; // return deleted ID if needed
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// // Helper function for async thunks
// const createAsyncCases = (builder, asyncThunk, key, stateKey = null) => {
//   builder
//     .addCase(asyncThunk.pending, (state) => {
//       state[`${key}Status`] = "loading";
//     })
//     .addCase(asyncThunk.fulfilled, (state, action) => {
//       state[`${key}Status`] = "succeeded";
//       if (stateKey) state[stateKey] = action.payload;
//     })
//     .addCase(asyncThunk.rejected, (state, action) => {
//       state[`${key}Status`] = "failed";
//       state[`${key}Error`] = action.error.message;
//     });
// };

// // Actual Slice
// const questionBankSlice = createSlice({
//   name: "questionBank",
//   initialState: {
//     classList: [],
//     subjects: [],
//     chapters: [],
//     questionTypes: [],
//     questions: [],
//     difficultyLevels: [],
//     selectedQuestionTypeId: null,
//     selectedClassId: null,
//     selectedSubjectId: null,
//     selectedChapterId: null,
//     classListStatus: "idle",
//     classListError: null,
//     subjectsStatus: "idle",
//     subjectsError: null,
//     chaptersStatus: "idle",
//     chaptersError: null,
//     addNewQuestion: false,
//     viewQuestion: false,
//     addFile: false,
//     specificQuestion: [],
//     newQuestion: {
//       difficulty_level: 1,
//       questionText: "",
//       passageText: "",
//       subQuestions: [],
//       options: ["", "", "", ""],
//       matchingPairs: [{ column1_text: "", column2_text: "" }],
//     },
//   },
//   reducers: {
//     setState: (state, action) => {
//       const { key, value } = action.payload;
//       state[key] = value;
//     },
//     setFormDetails: (state, action) => {
//       const { key, value } = action.payload;
//       state.newQuestion[key] = value;
//     },
//     addComprehensionQuestion: (state, action) => {
//       state.newQuestion.subQuestions.push(action.payload);
//     },
//     removeComprehensionQuestion: (state, action) => {
//       state.newQuestion.subQuestions.splice(action.payload, 1);
//     },
//   },
//   extraReducers: (builder) => {
//     createAsyncCases(builder, fetchClassesList, "classList", "classList");
//     createAsyncCases(builder, getSubjects, "subjects", "subjects");
//     createAsyncCases(builder, getChapters, "chapters", "chapters");
//     createAsyncCases(
//       builder,
//       fetchQuestionTypes,
//       "questionTypes",
//       "questionTypes"
//     );
//     createAsyncCases(builder, fetchQuestions, "questions", "questions");
//     createAsyncCases(
//       builder,
//       fetchDifficultyLevels,
//       "difficultyLevels",
//       "difficultyLevels"
//     );
//   },
// });

// // Export
// export const {
//   setState,
//   setFormDetails,
//   addComprehensionQuestion,
//   removeComprehensionQuestion,
// } = questionBankSlice.actions;

// export default questionBankSlice.reducer;

// subjects/redux/questionBankSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchQuestionTypes,
  addQuestionThunk,
  editQuestionThunk,
  fetchQuestionsThunk,
  fetchQuestionVariantsThunk,
  editVariantThunk,
} from "./questionBankThunk";

// const storedQuestionTypeId = localStorage.getItem("selectedQuestionTypeId");

const questionBankSlice = createSlice({
  name: "questionBank",
  initialState: {
    questionTypes: [],
    selectedQuestionTypeId: "",
    loadingQuestionTypes: false,
    errorQuestionTypes: null,
    editingQuestion: null,
    questions: [], // optional if you store them
    loading: false,
    error: null,
    subQuestionVariants: null,
    variantEditingQuestion: null,
    variantLoading: false,
    variantError: null,
    // You can add more states later like:
    // difficultyLevels: [],
    // chapters: [],
  },
  reducers: {
    setSelectedQuestionTypeId: (state, action) => {
      state.selectedQuestionTypeId = action.payload;

      // localStorage.setItem("selectedQuestionTypeId", action.payload);
    },
    clearSelectedQuestionTypeId: (state) => {
      state.selectedQuestionTypeId = "";
      localStorage.removeItem("selectedQuestionTypeId");
    },
    setEditingQuestion: (state, action) => {
      state.editingQuestion = action.payload;
    },
    clearEditingQuestion: (state) => {
      state.editingQuestion = null;
    },
    addQuestion: (state, action) => {
      state.questions.push(action.payload);
    },
    updateQuestion: (state, action) => {
      const index = state.questions.findIndex(
        (q) => q.id === action.payload.id
      );
      if (index !== -1) {
        state.questions[index] = action.payload;
      }
    },
    addQuestionsFromFile: (state, action) => {
      state.questions = [...state.questions, ...action.payload];
    },
    clearSubQuestionVariants: (state) => {
      state.subQuestionVariants = [];
    },
    setVariantEditingQuestion: (state, action) => {
      state.variantEditingQuestion = action.payload;
    },
    clearVariantEditingQuestion: (state) => {
      state.variantEditingQuestion = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestionTypes.pending, (state) => {
        state.loadingQuestionTypes = true;
        state.errorQuestionTypes = null;
      })
      // .addCase(fetchQuestionTypes.fulfilled, (state, action) => {
      //   state.loadingQuestionTypes = false;
      //   state.questionTypes = action.payload;

      //   // Validate current selection
      //   const isValid = action.payload.some(
      //     (type) => type.type_id.toString() === state.selectedQuestionTypeId
      //   );

      //   if (!isValid) {
      //     state.selectedQuestionTypeId = "";
      //     localStorage.removeItem("selectedQuestionTypeId");
      //   }
      // })
      .addCase(fetchQuestionTypes.fulfilled, (state, action) => {
        state.loadingQuestionTypes = false;

        // Ensure payload is an array
        const types = Array.isArray(action.payload)
          ? action.payload
          : action.payload?.data || [];

        state.questionTypes = types;

        const isValid = types.some(
          (type) => type.type_id.toString() === state.selectedQuestionTypeId
        );

        if (!isValid) {
          state.selectedQuestionTypeId = "";
          localStorage.removeItem("selectedQuestionTypeId");
        }
      })

      .addCase(fetchQuestionTypes.rejected, (state, action) => {
        state.loadingQuestionTypes = false;
        state.errorQuestionTypes = action.payload;
      })
      .addCase(addQuestionThunk.fulfilled, (state, action) => {
        state.questions.push(action.payload); // or re-fetch
      })
      .addCase(editQuestionThunk.fulfilled, (state, action) => {
        const idx = state.questions.findIndex(
          (q) => q.id === action.payload.id
        );
        if (idx !== -1) state.questions[idx] = action.payload;
      })
      .addCase(fetchQuestionsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.questions = [];
      })
      .addCase(fetchQuestionsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload || [];
        // Optional: Cache in localStorage
        if (action.payload?.length) {
          localStorage.setItem("questions", JSON.stringify(action.payload));
        } else {
          localStorage.removeItem("questions");
        }
      })
      .addCase(fetchQuestionsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
        state.questions = [];
        localStorage.removeItem("questions");
      })
      .addCase(fetchQuestionVariantsThunk.pending, (state) => {
        state.variantLoading = true;
        state.variantError = null;
      })
      .addCase(fetchQuestionVariantsThunk.fulfilled, (state, action) => {
        state.variantLoading = false;
        state.subQuestionVariants = action.payload; // ✅ Store full question object
      })
      .addCase(fetchQuestionVariantsThunk.rejected, (state, action) => {
        state.variantLoading = false;
        state.variantError = action.payload;
      });
  },
});

export const {
  setVariantEditingQuestion,
  clearVariantEditingQuestion,
  setSelectedQuestionTypeId,
  clearSelectedQuestionTypeId,
  clearSubQuestionVariants,
  setEditingQuestion,
  clearEditingQuestion,
  addQuestion,
  updateQuestion,
  addQuestionsFromFile,
} = questionBankSlice.actions;

export default questionBankSlice.reducer;
